//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import utils from "@/utils"
import api from "@/api"
export default {
  name: 'FooterMobile',
  props:['str'],
  data () {
    return {
      activeStr:'',
    }
  },
  created(){
      this.activeStr = this.str
  },
  methods:{
    functionClick(str){
      this.$router.push({name: str})
    },
  },
  
}



// WEBPACK FOOTER //
// ./src/components/mobile/FooterMobile.vue